<div class="c-block c-block--bordered">
  <dl class="c-decision__list">
    <dt class="c-decision__list-title">Unique ID</dt>
    <dd class="c-decision__list-description">{{CaseReference}}</dd>

    <dt class="c-decision__list-title">Property Address</dt>
    <dd class="c-decision__list-description">
      {{Address}}
    </dd>
    <dt class="c-decision__list-title">Status</dt>
    <dd class="c-decision__list-description">{{StatusText}}</dd>
    <!-- <dt class="c-decision__list-title">Submitted on</dt>
    <dd class="c-decision__list-description">{{SubmittedDate}}</dd> -->

  </dl>
</div>
@if (IsDipSuccess  && !IsSubmitted && !IsExpired) {
  <div class="c-wysiwyg">
    <h5 class="mb-2">We've pre-approved your loan of:</h5>
    <h4 class="mb-3">{{LoanAmount}}</h4>
    @if (!isSteppedProduct) {
      <div class="card card-options  mb-4">
        <div class="card-header d-flex pb-0">
          <h5 class="font-source mb-0 mt-3 align-self-center">
          Your offer consists of:</h5>
        </div>
        <div class="card-body">
          <div class="row mt-2 mt-sm-0">
            <div class="col-8 col-sm-4 col-lg-6 mb-md-2">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly instalment: </span>
              </h6>
            </div>
            <div class="col-4 col-sm-4 col-md-3 col-lg-3  mb-md-2">
              <h6 class="font-source">
                {{Payment}}
              </h6>
            </div>
            <div class="col-8 col-sm-4 col-lg-6  mb-2 mb-sm-0">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly interest rate: </span>
              </h6>
            </div>
            <div class="col-4 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
              <h6 class="font-source">
                {{ InterestRate }}
              </h6>
            </div>
          </div>
        </div>
      </div>
    }
    @if (isSteppedProduct) {
      <div class="card card-options mb-4">
        <div class="card-header d-flex pb-0">
          <h5 class="font-source mb-0 mt-3 align-self-center">
          Your offer consists of:</h5>
        </div>
        <div class="card-body">
          <div class="row mt-2 mt-sm-0">
            <div class="col-6  order-sm-1 col-sm-4 col-lg-6 d-none d-sm-block">
              &nbsp;
            </div>
            <div class="col-12 order-1  order-sm-2 col-sm-4 col-md-3 col-lg-3 small mb-2">
              First
              <br class="d-none d-sm-block"> 6 months
            </div>
            <div class="col-12 order-7 order-sm-3 col-sm-4 col-md-5 col-lg-3 small mb-2">
              Second
              <br class="d-none d-sm-block"> 6 months
            </div>
            <div class="col-8 order-3 order-sm-4 col-sm-4 col-lg-6 mb-md-2">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly instalment: </span>
              </h6>
            </div>
            <div class="col-4 order-4 order-sm-5 col-sm-4 col-md-3 col-lg-3  mb-md-2">
              <h6 class="font-source">
                {{Payment}}
              </h6>
            </div>
            <div class="col-8 order-8 d-flex d-sm-none">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly instalment: </span>
              </h6>
            </div>
            <div class="col-4 order-9 order-sm-6 col-md-5 col-sm-4 col-lg-3">
              <h6 class="font-source">
                &pound;{{revisedRepayment}}
              </h6>
            </div>
            <div class="col-8 order-5 order-sm-7 col-sm-4 col-lg-6  mb-2 mb-sm-0">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly interest rate: </span>
              </h6>
            </div>
            <div class="col-4 order-6 order-sm-8 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
              <h6 class="font-source">
                {{InterestRate}}
              </h6>
            </div>
            <div class="col-8 order-10 d-flex d-sm-none mb-2 mb-sm-0">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly interest rate: </span>
              </h6>
            </div>
            <div class="col-4 order-11 order-sm-9 col-sm-4 col-md-5 col-lg-3">
              <h6 class="font-source">
                {{revisedRate}}
              </h6>
            </div>
          </div>
        </div>
      </div>
    }
    <p>
      <button class="c-button c-button--inverse" (click)="_handleShowCertificate()">Your offer in full <svg class="c-button__icon c-button__icon--right icon-document" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25"><path fill="none" stroke="#fff" stroke-miterlimit="10" d="M.5 23.37V.5h18.75l1.25 1.26v18.67l-4.04 4.07H1.49L.5 23.37z"/><path fill="none" stroke="#fff" stroke-miterlimit="10" d="M14.33 23.4v-5.65h5.03M4.22 4.74h12.56M4.22 8.63h12.56M4.22 12.65h12.56"/></svg></button><br
      />
    </p>
    <p>
      You can edit your details, but any changes you make may mean we need to check and re-approve your request.
    </p>
    <p>
      <button class="c-button c-button--neutral" (click)="_handleEdit()">Edit and re-submit <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.06 14.71"><path fill="none" stroke="#000" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7"/></svg></button><br
      />
    </p>
    <p>
      When you're ready, you can progress to a full application, it only takes a few minutes. You can review all the information you've given us; we just need some additional information. You'll still have access to your pre-approved loan offer.
    </p>
    <button class="c-button c-button--accent" (click)="_handleFullApplication()">Complete your details <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.06 14.71"><path fill="none" stroke="#000" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7"/></svg></button><br
    />
  </div>
}
@if (IsReferral  && !IsSubmitted) {
  <p>
    We’ll be in touch to let you know if we’ve been able to pre-approve your loan, normally within one working day. In the meantime, if you’d like to speak to us call our team on <a href="tel:+01614513157"><b>0161 768 5337</b></a>.
    <a href="http://www.togethermoney.com" target="_blank" title="Visit our website">Visit our website</a> to find out everything from how auction finance works, to handy tips for the big day.
  </p>
}
@if (IsRejected  && !IsSubmitted) {
  <div class="c-wysiwyg">
    <p>
      Our experienced team carefully reviewed all the information you provided and unfortunately, on this occasion, we’re not able to pre approve your loan.
    </p>
    <p>
      We’re sorry we can’t help this time, but if things change for you, or you’re considering another property in the future, we’d like to see if we can help.
    </p>
    <p>
      You can reach our team on <strong><a href="tel:+01614513157">0161 768 5337</a>.</strong>
    </p>
    <p>
      Alternatively, <a href="http://www.togethermoney.com" target="_blank" title="Visit our website">visit our website</a> to find out everything from how auction finance works, to handy tips for the big day.
    </p>
    <p>
      Thank you for considering us.
    </p>
  </div>
}
@if (IsExpired  && !IsSubmitted) {
  <div class="c-wysiwyg">
    <p>It's been a while since we pre-approved your loan of {{LoanAmount}}; we'll need to renew our offer if you still need a loan.</p>
    <p>You now have the opportunity to copy and change any of the details you've already provided, and then submit a new request for pre-approval.</p>
    <button class="c-button c-button--inverse" (click)="handleCopyCase()">Copy and create a new request</button><br />
  </div>
}
@if (IsInProgress  && !IsSubmitted) {
  <div class="c-wysiwyg">
    <p>You've nearly finished providing the information we need; you can review and change any information, or just pick up where you left off.</p>
    <button class="c-button c-button--inverse" (click)="_handleEdit()">Edit your {{EditButtonText}}
      <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.06 14.71"><path fill="none" stroke="#000" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7"/></svg>
    </button><br />
  </div>
}
@if (IsSubmitted && IsDipSuccess) {
  <div class="c-wysiwyg">
    <h5 class="mb-2">We've pre-approved your loan of:</h5>
    <h4 class="mb-3">{{LoanAmount}}</h4>
    @if (!isSteppedProduct) {
      <div class="card card-options  mb-4">
        <div class="card-header d-flex pb-0">
          <h5 class="font-source mb-0 mt-3 align-self-center">
          Your offer consists of:</h5>
        </div>
        <div class="card-body">
          <div class="row mt-2 mt-sm-0">
            <div class="col-8 col-sm-4 col-lg-6 mb-md-2">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly instalment: </span>
              </h6>
            </div>
            <div class="col-4 col-sm-4 col-md-3 col-lg-3  mb-md-2">
              <h6 class="font-source">
                {{Payment}}
              </h6>
            </div>
            <div class="col-8 col-sm-4 col-lg-6  mb-2 mb-sm-0">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly interest rate: </span>
              </h6>
            </div>
            <div class="col-4 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
              <h6 class="font-source">
                {{ InterestRate }}
              </h6>
            </div>
          </div>
        </div>
      </div>
    }
    @if (isSteppedProduct) {
      <div class="card card-options mb-4">
        <div class="card-header d-flex pb-0">
          <h5 class="font-source mb-0 mt-3 align-self-center">
          Your offer consists of:</h5>
        </div>
        <div class="card-body">
          <div class="row mt-2 mt-sm-0">
            <div class="col-6  order-sm-1 col-sm-4 col-lg-6 d-none d-sm-block">
              &nbsp;
            </div>
            <div class="col-12 order-1  order-sm-2 col-sm-4 col-md-3 col-lg-3 small mb-2">
              First
              <br class="d-none d-sm-block"> 6 months
            </div>
            <div class="col-12 order-7 order-sm-3 col-sm-4 col-md-5 col-lg-3 small mb-2">
              Second
              <br class="d-none d-sm-block"> 6 months
            </div>
            <div class="col-8 order-3 order-sm-4 col-sm-4 col-lg-6 mb-md-2">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly instalment: </span>
              </h6>
            </div>
            <div class="col-4 order-4 order-sm-5 col-sm-4 col-md-3 col-lg-3  mb-md-2">
              <h6 class="font-source">
                {{Payment}}
              </h6>
            </div>
            <div class="col-8 order-8 d-flex d-sm-none">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly instalment: </span>
              </h6>
            </div>
            <div class="col-4 order-9 order-sm-6 col-md-5 col-sm-4 col-lg-3">
              <h6 class="font-source">
                &pound;{{revisedRepayment}}
              </h6>
            </div>
            <div class="col-8 order-5 order-sm-7 col-sm-4 col-lg-6  mb-2 mb-sm-0">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly interest rate: </span>
              </h6>
            </div>
            <div class="col-4 order-6 order-sm-8 col-sm-4 col-md-3 col-lg-3 mb-2 mb-md-0">
              <h6 class="font-source">
                {{InterestRate}}
              </h6>
            </div>
            <div class="col-8 order-10 d-flex d-sm-none mb-2 mb-sm-0">
              <h6 class="font-source">
                <span class="text-dark font-weight-light"> Monthly interest rate: </span>
              </h6>
            </div>
            <div class="col-4 order-11 order-sm-9 col-sm-4 col-md-5 col-lg-3">
              <h6 class="font-source">
                {{revisedRate}}
              </h6>
            </div>
          </div>
        </div>
      </div>
    }
    <button class="c-button c-button--inverse" (click)="_handleShowCertificate()">Your offer in full <svg class="c-button__icon c-button__icon--right icon-document" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25"><path fill="none" stroke="#fff" stroke-miterlimit="10" d="M.5 23.37V.5h18.75l1.25 1.26v18.67l-4.04 4.07H1.49L.5 23.37z"/><path fill="none" stroke="#fff" stroke-miterlimit="10" d="M14.33 23.4v-5.65h5.03M4.22 4.74h12.56M4.22 8.63h12.56M4.22 12.65h12.56"/></svg></button><br
    />
  </div>
}
<together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>
